// extracted by mini-css-extract-plugin
export var arrow = "GalleryModule-module--arrow--4ebRn";
export var arrowDisabled = "GalleryModule-module--arrowDisabled--Hmqb5";
export var arrowIcon = "GalleryModule-module--arrowIcon--R0+jZ";
export var arrowNext = "GalleryModule-module--arrowNext--9fHz-";
export var arrowPrev = "GalleryModule-module--arrowPrev--d41iT";
export var autoPlayControlIcon = "GalleryModule-module--autoPlayControlIcon--ymj77";
export var autoplayControl = "GalleryModule-module--autoplayControl--9JDG0";
export var autoplayControlWithCaption = "GalleryModule-module--autoplayControlWithCaption--bfBnA";
export var component = "GalleryModule-module--component--jGRjd";
export var dots = "GalleryModule-module--dots--7f1nK";
export var inner = "GalleryModule-module--inner--eNksu";